module.exports = __webpack_public_path__ + "static/img/form-logo.ff430362.png";